// staging vars
const config = {
  firebaseApiKey: "AIzaSyC7y6Pjn9d4gg7SLGuC_XQFGe0lXY3ifeE",
  firebaseProjectId: "s6isawesome",
  firebaseMessagingSenderId: "478650693196",
  buckets: {
    eu: "gs://screen6-amp-staging-eu",
    us: "gs://screen6-amp-staging-us",
  }
};

module.exports = config;



// WEBPACK FOOTER //
// ./src/config/staging.js